import React, { useState, useEffect } from "react";
import { Form, Row, Col, Button } from "react-bootstrap";
import { toast } from "react-toastify";
import { GetBusinessCategoryApi } from "../API/Coupons/GetBusinessCategoryApi";
import { CreateMarketplaceBusinessApi } from "../API/Coupons/CreateMarketplaceBusinessApi";
import { FroalaTextEditor } from "../FroalaEditor/FroalaTextEditor";
import SideBar from "../SideBar/SideBar";
import BackButton from "../BackButton/BackButton";
import Modals from "../modals/Modals";
import Warning from "../../assets/Warning.svg";
import ErrorLabel from "../ErrorLabel/ErrorLabel";
import { useNavigate, useParams } from "react-router-dom";

const CreateBussiness = () => {
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [businessName, setBusinessName] = useState("");
  const [businessDescription, setBusinessDescription] = useState("");
  const [businessUrl, setBusinessUrl] = useState("");
  const [contactNumber, setContactNumber] = useState("");
  const [contactEmail, setContactEmail] = useState("");
  const [secondaryEmail, setSecondaryEmail] = useState("");
  const [modalShow, setModalShow] = useState(false);
  const [dataApihandler, setDataApihandler] = useState({});
  const navigate = useNavigate();
  // Error States
  const [categoryError, setCategoryError] = useState("");
  const [businessNameError, setBusinessNameError] = useState("");
  const [businessDescriptionError, setBusinessDescriptionError] = useState("");
  const [businessUrlError, setBusinessUrlError] = useState("");
  const [contactNumberError, setContactNumberError] = useState("");
  const [contactEmailError, setContactEmailError] = useState("");
  const [secondaryEmailError, setSecondaryEmailError] = useState("");

  const getCategoryList = async () => {
    try {
      const marketplaceId = localStorage.getItem("cityId");
      const res = await GetBusinessCategoryApi(marketplaceId, () => {
        navigate("/");
      });
      console.log("Category Response:", res);
      setCategories(res?.data || []);
    } catch (err) {
      console.log(err);
      toast.error("Failed to fetch categories");
    }
  };

  useEffect(() => {
    getCategoryList();
  }, []);

  const resetForm = () => {
    setSelectedCategory("");
    setBusinessName("");
    setBusinessDescription("");
    setBusinessUrl("");
    setContactNumber("");
    setContactEmail("");
    setSecondaryEmail("");

    // Clear all errors
    setCategoryError("");
    setBusinessNameError("");
    setBusinessDescriptionError("");
    setBusinessUrlError("");
    setContactNumberError("");
    setContactEmailError("");
    setSecondaryEmailError("");
  };

  // Fixed to receive email argument
  const isValidEmail = (email) => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
  };

  const handleSubmit = () => {
    let flag = false;

    // Reset all errors before validation pass
    setCategoryError("");
    setBusinessNameError("");
    setBusinessDescriptionError("");
    setContactNumberError("");
    setContactEmailError("");
    setSecondaryEmailError("");

    if (!selectedCategory.trim()) {
      setCategoryError("Please select category!");
      flag = true;
    }
    if (!businessName.trim()) {
      setBusinessNameError("Please enter business name!");
      flag = true;
    }
    if (!businessDescription.trim()) {
      setBusinessDescriptionError("Please enter business description!");
      flag = true;
    }
    if (!contactNumber.trim()) {
      setContactNumberError("Please enter contact number!");
      flag = true;
    }
    if (!contactEmail.trim()) {
      setContactEmailError("Please enter contact email!");
      flag = true;
    } else if (!isValidEmail(contactEmail.trim())) {
      setContactEmailError("Please enter valid email!");
      flag = true;
    }
    if (secondaryEmail.trim()) {
      if (!isValidEmail(secondaryEmail.trim())) {
        setSecondaryEmailError("Please enter valid email!");
        flag = true;
      }
    }

    if (flag === true) {
      setTimeout(() => {
        const errorElements = document.querySelectorAll(".coupon-error-msg");

        let firstActiveError = null;
        for (const el of errorElements) {
          if (el.textContent?.trim()) {
            firstActiveError = el;
            break;
          }
        }

        if (firstActiveError) {
          const parentRow =
            firstActiveError.closest(".row") || firstActiveError.parentElement;

          if (parentRow) {
            parentRow.scrollIntoView({
              behavior: "smooth",
              block: "center",
            });

            const mainContent = document.querySelector(".main-content");
            if (mainContent) {
              const topPos =
                parentRow.getBoundingClientRect().top +
                mainContent.scrollTop -
                150;
              mainContent.scrollTo({
                top: topPos,
                behavior: "smooth",
              });
            }
          }
        }
      }, 100);
      return;
    }

    if (flag === false) {
      // setModalShow(true);
      handleSaveBusiness();
    }
  };

  const handleSaveBusiness = async () => {
    try {
      const payload = {
        business_name: businessName,
        business_description: businessDescription,
        contact: contactNumber,
        category: Number(selectedCategory),
        primary_email: contactEmail,
        secondary_email: secondaryEmail,
        online_url: businessUrl,
        mms_city_id: Number(localStorage.getItem("cityId")),
      };

      console.log("Create Business Payload:", payload);
      const response = await CreateMarketplaceBusinessApi(payload, () => {
        navigate("/");
      });
      console.log("Create Business Response:", response);

      if (response.status) {
        toast.success(
          response?.data?.message || "Business created successfully",
          {
            position: "top-center",
            width: "500px",
            autoClose: 2000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "dark",
          },
        );
      }
      navigate("/coupons/bussiness-listing");
      resetForm();
    } catch (error) {
      console.log(error);
      toast.error(
        error?.response?.data?.message || "Failed to create business",
      );
    } finally {
      setModalShow(false);
    }
  };

  return (
    <>
      <div className="gray-bg">
        <div className="navbar-section p-0">
          <SideBar />
        </div>
        <div className="main-content pt-5 pr-3 pb-4">
          <BackButton />
          <p className="page-maintitle">Create Business</p>

          <div className="acc-dashboard mt-4">
            <Form className="formmain mx-0 mt-2 signin-row profile-form pb-4">
              {/* Category & Business Name */}
              <Row className="mb-1">
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>
                      Category <span className="text-danger">*</span>
                    </Form.Label>

                    <Form.Select
                      value={selectedCategory}
                      onChange={(e) => {
                        setSelectedCategory(e.target.value);
                        if (e.target.value) setCategoryError("");
                      }}
                    >
                      <option value="">Select Category</option>

                      {categories?.map((item) => (
                        <option key={item.category_id} value={item.category_id}>
                          {item.category_name}
                        </option>
                      ))}
                    </Form.Select>
                    <div className="coupon-error-msg">
                      <ErrorLabel ErrorDisplay={categoryError} />
                    </div>
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>
                      Business Name <span className="text-danger">*</span>
                    </Form.Label>

                    <Form.Control
                      type="text"
                      value={businessName}
                      onChange={(e) => {
                        setBusinessName(e.target.value);
                        if (e.target.value.trim()) setBusinessNameError("");
                      }}
                      placeholder="Enter business name"
                    />
                    <div className="coupon-error-msg">
                      <ErrorLabel ErrorDisplay={businessNameError} />
                    </div>
                  </Form.Group>
                </Col>
              </Row>

              {/* Online URL */}
              <Row className="mb-1">
                <Col md={12}>
                  <Form.Group>
                    <Form.Label>Online URL</Form.Label>

                    <Form.Control
                      type="text"
                      value={businessUrl}
                      onChange={(e) => {
                        setBusinessUrl(e.target.value);
                        if (e.target.value.trim()) setBusinessUrlError("");
                      }}
                      placeholder="https://example.com"
                    />
                    <div className="coupon-error-msg">
                      <ErrorLabel ErrorDisplay={businessUrlError} />
                    </div>
                  </Form.Group>
                </Col>
              </Row>

              {/* Contact Details */}
              <Row className="mb-1">
                <Col md={4}>
                  <Form.Group>
                    <Form.Label className="info-sec">
                      Contact Number <span className="text-danger">*</span>
                      <p className="info-text-space-f13">(for customer)</p>
                    </Form.Label>

                    <Form.Control
                      type="text"
                      value={contactNumber}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (/^\d*$/.test(value)) {
                          setContactNumber(value);
                          if (value.trim()) setContactNumberError("");
                        }
                      }}
                      placeholder="Enter contact number"
                    />
                    <div className="coupon-error-msg">
                      <ErrorLabel ErrorDisplay={contactNumberError} />
                    </div>
                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Form.Group>
                    <Form.Label className="info-sec">
                      Contact Email <span className="text-danger">*</span>{" "}
                      <p className="info-text-space-f13">(for customer)</p>
                    </Form.Label>

                    <Form.Control
                      type="email"
                      value={contactEmail}
                      onChange={(e) => {
                        setContactEmail(e.target.value);
                        if (e.target.value.trim()) setContactEmailError("");
                      }}
                      placeholder="Enter contact email"
                    />
                    <div className="coupon-error-msg">
                      <ErrorLabel ErrorDisplay={contactEmailError} />
                    </div>
                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Form.Group>
                    <Form.Label className="info-sec">
                      Business Contact Email{" "}
                      <span className="text-danger"></span>{" "}
                      <p className="info-text-space-f13"></p>
                    </Form.Label>

                    <Form.Control
                      type="email"
                      value={secondaryEmail}
                      onChange={(e) => {
                        setSecondaryEmail(e.target.value);
                        if (e.target.value.trim()) setSecondaryEmailError("");
                      }}
                      placeholder="Enter secondary email"
                    />
                    <div className="coupon-error-msg">
                      <ErrorLabel ErrorDisplay={secondaryEmailError} />
                    </div>
                  </Form.Group>
                </Col>
              </Row>

              {/* Business Description */}
              <Row className="mb-1">
                <Col md={12}>
                  <Form.Group>
                    <Form.Label>
                      Business Description{" "}
                      <span className="text-danger">*</span>
                    </Form.Label>

                    <FroalaTextEditor
                      TemplateContent={businessDescription}
                      setTemplateContent={(content) => {
                        setBusinessDescription(content);
                        if (content.trim()) setBusinessDescriptionError("");
                      }}
                    />
                    <div className="coupon-error-msg">
                      <ErrorLabel ErrorDisplay={businessDescriptionError} />
                    </div>
                  </Form.Group>
                </Col>
              </Row>
              {/* Buttons */}
              <div className="d-flex justify-content-center gap-4 mt-4">
                <Button
                  className="discard_btn"
                  variant="secondary"
                  onClick={() => {
                    navigate("/coupons/bussiness-listing");
                  }}
                >
                  Cancel
                </Button>

                <Button
                  className="green-btn mt-3 update-Btn"
                  variant="primary"
                  onClick={handleSubmit}
                >
                  Save Business
                </Button>
              </div>
            </Form>
          </div>
        </div>
      </div>
    </>
  );
};

export default CreateBussiness;
